// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","heroImage":"Hero_heroImage__WlCwT","heroText":"Hero_heroText__w7yrF"};